import React from 'react';
import PropTypes from 'prop-types';
import './Tab.css';

const Tab = props => (
  <button
    onClick={props.onClick}
    className={props.active ? 'tab tab--active' : 'tab'}
    type="button"
  >
    {props.children}
  </button>
);

Tab.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default Tab;



// WEBPACK FOOTER //
// ./src/components/Tab/Tab.jsx